import { OkrMetric } from "server/models"
import { inferLiteral } from "client/utils"
import * as types from "./types"


export const setOkrMetricList = (metricList: types.OkrMetricList) => ({
    type: inferLiteral(types.OKR_METRIC_LIST),
    metricList,
})
export const setOkrMetricIds = (metricIds: readonly number[]) => ({
    type: inferLiteral(types.OKR_METRIC_IDS),
    metricIds,
})
export const setOkrMetricEdit = (value: OkrMetric) => ({
    type: inferLiteral(types.OKR_METRIC_EDIT),
    value,
})
export const setOkrMetricReloadList = (value: boolean) => ({
    type: inferLiteral(types.OKR_METRIC_RELOAD_LIST),
    value,
})
export const setOkrMetricReloadEdit = (value: boolean) => ({
    type: inferLiteral(types.OKR_METRIC_RELOAD_EDIT),
    value,
})
